<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Podcast</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/podcasts" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createPodcast" v-if="podcasts">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-12">
                                <fg-input type="text"
                                          v-model="podcasts.serviceName"
                                          label="Service Name"
                                          placeholder="BUZZSPROUT"
                                          v-validate="rules.serviceName"
                                          data-vv-name="serviceName"
                                          cus-name="serviceName"
                                          readonly="true"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="podcasts.podcastUrl"
                                      label="Podcast URL"
                                      placeholder="Enter podcasts Url"
                                      data-vv-name="podcastUrl"
                                      v-validate="rules.podcastUrl"
                                      cus-name="podcastUrl"
                                      :has-errors="errors"
                                      :is-fields="fields"
                                      >
                            </fg-input>
                          </div>

                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="podcasts.readMoreUrl"
                                      label="Podcast Read More URL"
                                      placeholder="Enter podcasts read more Url"
                                      data-vv-name="readMoreUrl"
                                      v-validate="rules.podcastUrl"
                                      cus-name="readMoreUrl"
                                      :has-errors="errors"
                                      :is-fields="fields"
                            >
                            </fg-input>
                          </div>

                            <div class="col-3" v-if="status.length">
                              <fg-select
                                v-model="podcasts.active"
                                label="isActive"
                                v-validate="rules.active"
                                data-vv-name="active"
                                cus-name="active"
                                :has-errors="errors"
                                :is-fields="fields"
                                :list="status"
                                selectedKey="id"
                              >
                              </fg-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Podcast
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreatePodcast',
        created (){
    },
    data () {
        return {
            podcasts: {
              serviceName: 'buzzsprout',
              podcastUrl: '',
              readMoreUrl: '',
              active: '1',
            },
          corps: [],
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            rules: {
              serviceName: {required : true},
              podcastUrl: {required : true},
              readMoreUrl: {required : true},
              active: {required: true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
        createPodcast () {
          console.log("this.podcasts : ", this.podcasts);
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_PODCAST', this.podcasts)
                .then((res) => {
                  console.log("ADD_PODCAST res : ", res);
                  if(res) this.showPopup('Success!', 'podcasts is successfully created', 'success', ()=>this.$router.push('/admin/podcasts'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_PODCAST API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {
      // this.fetchCorporations();
    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Podcast/CreatePodcast.vue